import React from "react";
import {FormLevelErrorDiv, FormLevelErrorField} from "../../Registration/widgets/Styled";
import {useFormState} from "react-final-form";
import {FormUlList} from "../../Registration/widgets/loaderStyled";

interface FormLevelErrorProps {
    formLevelErrorTag?: boolean;
}
const FormLevelError: React.FC<FormLevelErrorProps> = ({
    formLevelErrorTag = false,
}: FormLevelErrorProps) => {
    const {submitError, dirtySinceLastSubmit} = useFormState({
        subscription: {submitError: true, dirtySinceLastSubmit: true},
    }) as {submitError: string; dirtySinceLastSubmit: boolean};

    if (!dirtySinceLastSubmit && submitError) {
        return (
            <>
                {formLevelErrorTag ? (
                    <FormLevelErrorDiv>
                        <FormLevelErrorField>{submitError}</FormLevelErrorField>
                    </FormLevelErrorDiv>
                ) : (
                    <FormUlList fullWidthDiv>
                        <FormLevelErrorField>{submitError}</FormLevelErrorField>
                    </FormUlList>
                )}
            </>
        );
    }
    return null;
};

export default FormLevelError;
